import { FileExcelOutlined, UploadOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import { CommandBar, SearchBox } from "@fluentui/react";
import { Button, notification, Tooltip, Skeleton, Empty } from "antd";

import React, { createContext, useContext, useEffect } from "react";
import {
  BarChart,
  BarChart2,
  FilePlus,
  FileText,
  PieChart,
  RefreshCcw,
  ZoomIn,
} from "react-feather";
import { FilterCallOut } from "../../../shared/FilterCallOut";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";

import MaterialStore from "../store/materialstore";
import ReportStore from "../../../shared/ReportStore";
import moment from "moment";
import { useRef } from "react";

import { NoData } from "../../../shared/NoData";
import { observer } from "mobx-react-lite";
import WizardStore from "../store/wizardstore";
import formatNumber from "accounting-js/lib/formatNumber";
import PreferenceStore from "../../home/store/preferenceStore";
const Preferencestore = createContext(PreferenceStore);
const materialStoreCtx = createContext(MaterialStore);
const reportStoreCtx = createContext(ReportStore);
const wizardStoreCtx = createContext(WizardStore);

export const MaterialGrid = observer(() => {
  const materialStore = useContext(materialStoreCtx);
  const materialGrid = useRef(null);
  const wizardStore = useContext(wizardStoreCtx);
  const reportStore = useContext(reportStoreCtx);
  const preferenceStore = useContext(Preferencestore);

  useEffect(() => {
    async function loadConsumptions() {
      try {
        await materialStore.loadConsumptions();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadConsumptions();
  }, []);
  const refreshData = async () => {
    materialStore.queryCriteria = {
      startDate: moment(new Date())
        .startOf("month")
        .format("YYYY-MM-DDT00:00:00.000Z"),
      endDate: moment(new Date())
        .endOf("month")
        .format("YYYY-MM-DDT00:00:00.000Z"),
      fromInception: false,
      specificDate: false,
    };
    await materialStore.loadConsumptions();
  };
  const refreshHandler = async () => {};
  const rowSelected = () => {};
  const sortChanged = () => {};

  const addNewConsumptions = () => {
    wizardStore.current = 0;
    materialStore.showWizardDialog = true;
    wizardStore.importConsumptions.clear();
    wizardStore.uploadErrors.clear();
  };

  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: 2,
        thousand: ",",
      });
    }
  };

  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        rowDrag: true,

        width: 80,
        hide: true,
        pivot: false,
      },

      {
        headerName: "CHEMICAL INJECTION DATA",
        headerClass: "oilheader",
        children: [
          {
            headerName: "MATERIAL CONSUMPTION SHEET",
            children: [
              {
                headerName: "PDY",
                field: "pdYear",
                sortable: true,
                resizable: true,
                pivot: true,

                hide: true,
                width: 80,
              },
              {
                headerName: "PDYM",
                field: "pdYearMonth",
                sortable: true,
                resizable: true,
                hide: true,
                width: 100,
              },
              {
                headerName: "Production Date",
                field: "productionDate",
                type: ["dateColumn", "nonEditableColumn"],
                sortable: true,
                resizable: true,
                width: 120,
                valueFormatter: (props) => {
                  if (!props.data?.productionDate) {
                    return "";
                  }

                  return moment(props.data?.productionDate).format(
                    preferenceStore.preference.dateFormat
                  );
                },

                cellRenderer: "agGroupCellRenderer",
              },
              {
                headerName: "Chemical",
                field: "chemical",
                width: 150,
                resizable: true,
                sortable: true,
                pivot: false,
                filter: true,
              },
              {
                headerName: "Unit",
                field: "unit",
                width: 80,
                resizable: true,
                sortable: true,
                pivot: false,
              },
              {
                headerName: "Previous day Stock",
                field: "openingStock",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "rgb(204,218,236)",
                },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Usage",
                field: "usage",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 100,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Available Stock",
                field: "closingStock",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "right", backgroundColor: "#ffcdd2" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
            ],
          },

          {
            headerName: "AUDIT",

            children: [
              {
                headerName: "Uploaded(Modified) By",
                field: "uploadedBy",
                filter: true,
                sortable: true,
                resizable: true,
              },
              {
                headerName: "Uploaded On",
                field: "uploadedOn",
                sortable: true,
                resizable: true,
                filter: true,
                cellRenderer: function (props) {
                  return moment(props.data.uploadedOn).format(
                    "ddd DD.MM.YYYY , h:mm:ss a"
                  );
                },
              },
            ],
          },
        ],
      },
    ],
  };
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm7" style={{ display: "flex" }}>
          <SubPageHeaderTitle title={`${materialStore.gridHeaderText}`} />
        </div>
        <div
          className="ms-Grid-col ms-sm5"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            type="primary"
            onClick={() => {
              addNewConsumptions();
            }}
          >
            Add New Consumption
          </Button>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "filtert1",
                onRenderIcon: () => <FilterCallOut />,
              },
              {
                key: "refresh",
                text: (
                  <Tooltip title="Refresh daily production data">
                    Refresh
                  </Tooltip>
                ),

                onRenderIcon: () => <RefreshCcw className="qicon" />,

                onClick: async () => {
                  await refreshData();
                },
              },
              /*  {
                key: "modify",
                text: (
                  <Tooltip title="Modify or edit selected daily production figures">
                    Modify
                  </Tooltip>
                ),
                disabled: materialStore.disableCommand,
                onRenderIcon: () => <Edit3 className="qicon" />,

                onClick: async () => {
                  if (materialStore.selRow) {
                    materialStore.initFormaData = materialStore.selRow;
                    materialStore.view = "manual";
                    materialStore.uploadDate = moment(
                      materialStore.selRow.productionDate
                    );
                    materialStore.showNaocDailyProductionDialog = true;
                  }
                },
              },

              {
                key: "remove",
                text: (
                  <Tooltip title="Remove or delete selected daily production data with action logged ">
                    Remove
                  </Tooltip>
                ),
                name: "delete",
                disabled: materialStore.disableCommand,
                // disabled: accountStore.userCommandBarDisabled,

                onRenderIcon: () => <Trash2 className="qicon" />,
                onClick: () => {
                  const seldata = materialGrid.current.api.getSelectedNodes()[0];
                  console.log(seldata);

                  if (!seldata) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select production data row to remove",
                    });
                    return;
                  }

                  confirm({
                    icon: <QuestionOutlined />,
                    title: "Delete production",
                    content: (
                      <div
                        className="ms-Grid"
                        dir="ltr"
                        style={{ padding: "10px" }}
                      >
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12">
                            Confirm removal of production data
                          </div>
                        </div>
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm12"
                            style={{ fontStyle: "italic", padding: "10px" }}
                          >
                            <ExclamationCircleOutlined
                              style={{ color: "red" }}
                            />{" "}
                            this operation will be logged
                          </div>
                        </div>
                      </div>
                    ),
                    onOk: async () => {
                      try {
                        const seldata = materialGrid.current.api.getSelectedNodes()[0];
                        const id = seldata.data.naocDailyProductionId;
                        if (id) {
                          const retVal = await materialStore.deleteProduction(
                            id
                          );
                          if (retVal.success) {
                            materialStore.materialConsumptions.delete(
                              retVal.prodId
                            );
                            message.success(
                              "Production record deleted successfully"
                            );
                          }
                        }
                      } catch (error) {
                        notification.error({
                          message: "SPARS Feedback",
                          description: error.message,
                        });
                      }
                    },
                    onCancel() {
                      console.log("Cancel");
                    },
                  });
                },
              }, */
              {
                key: "spacere",
                onRender: () => <div style={{ width: "30px" }} />,
              },
              {
                key: "access",

                text: (
                  <Tooltip title="perform quick query on  material consumption">
                    Material Query
                  </Tooltip>
                ),

                onRenderIcon: () => <ZoomIn className="qicon" />,

                onClick: () => {
                  materialStore.showMQeryDialog = true;
                },
              },
              {
                key: "spacer2",
                onRender: () => <div style={{ width: "20px" }} />,
              },

              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the production data displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        materialGrid.current.api.setQuickFilter(searchTerms);
                        // const filterValue = grid.current.api.filterManager.quickFilter;
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
            ]}
            farItems={[
             
              
              {
                key: "group4",

                text: (
                  <Tooltip title="Export displayed Material consumption data to excel">
                    Export to Excel
                  </Tooltip>
                ),
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                onClick: async () => {
                  try {
                    materialStore.isExporting = true;
                    await materialGrid.current.api.exportDataAsExcel({
                      sheetName: "Material consumption",
                      allColumns: true,

                      skipFooters: false,
                      skipGroups: false,
                      skipHeader: false,
                      skipPinnedTop: false,
                      skipPinnedBottom: false,
                      fileName: `${materialStore.mainStore.assetContextName}_material_consumption_data`,
                      skipColumnGroupHeaders: false,
                      skipColumnHeaders: false,
                      columnGroups: true,
                    });
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: "export failed",
                    });
                  } finally {
                    materialStore.isExporting = false;
                  }
                },
              },
            ]}
          />
        </div>
      </div>
      {materialStore.isLoading ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div
            className="ag-theme-balham qikreach-grid-fill"
          style={{
            minHeight: "50vh",
            height: "100vh",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {materialStore.materialConsumptions.size > 0 ? (
            <AgGridReact
              rowData={[...materialStore.materialConsumptions.values()]}
              sideBar={["columns", "filters"]}
              ref={materialGrid}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                  enableRowGroup: true,
                  enablePivot: true,
                },
                enableCharts: true,
                enableRangeSelection: true,

                rowSelection: "single",
                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,
                statusBar: {
                  statusPanels: [
                    {
                      statusPanel: "agTotalRowCountComponent",
                      align: "center",
                    },
                  ],
                },
                columnTypes: {
                  numberColumn: {
                    width: 130,
                    filter: "agNumberColumnFilter",
                  },
                  medalColumn: {
                    width: 100,
                    columnGroupShow: "open",
                    filter: false,
                  },
                  nonEditableColumn: { editable: false },
                  dateColumn: {
                    filter: "agDateColumnFilter",
                    filterParams: {
                      comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                      ) {
                        var dateParts = cellValue.split("/");
                        var day = Number(dateParts[0]);
                        var month = Number(dateParts[1]) - 1;
                        var year = Number(dateParts[2]);
                        var cellDate = new Date(year, month, day);
                        if (cellDate < filterLocalDateAtMidnight) {
                          return -1;
                        } else if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        } else {
                          return 0;
                        }
                      },
                    },
                  },
                },
              }}
              rowSelection={{ mode: "singleRow", checkboxes: true, enableClickSelection: true }}
              onSelectionChanged={rowSelected}
              onSortChanged={sortChanged}
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
            ></AgGridReact>
          ) : materialStore.materialConsumptions.size === 0 &&
            materialStore.resultFromQuery === false ? (
            <div className="ms-Grid" dir="ltr" style={{}}>
              <div className="ms-Grid-row">
                <div
                  className="ms-Grid-col ms-sm12"
                  style={{
                    height: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Empty
                    description={`No Material Consumption Upload for  ${moment(
                      materialStore.queryCriteria.startDate
                    ).format("MMM YYYY")}`}
                  />
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "20px" }}
                    >
                      {" "}
                      <Button
                        type="danger"
                        icon={<UploadOutlined />}
                        onClick={() => {
                          addNewConsumptions();
                        }}
                      >
                        Start Material Consumption Upload
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <NoData
              title="No Material Consumption Record Found"
              subTitle="Sorry, No Material Consumption record found for the selected production date"
              clickHandler={refreshHandler}
            />
          )}
        </div>
      )}
    </div>
  );
});

